import { DayHeaderContentArg } from "@fullcalendar/core";
import { DateTime } from "luxon";
import { Row } from "../Row";
import { WarningIndicator } from "../WarningIndicator";

export function CalendarDayHeaderContent(props: {
  arg: DayHeaderContentArg;
  warningsByDay: Map</* "yyyy-MM-dd" */ string, string | Array<string>>;
}) {
  const {
    arg: { text, date },
    warningsByDay,
  } = props;
  const day = DateTime.fromJSDate(date).toISODate();
  const warnings = warningsByDay.get(day);
  return (
    <Row alignItems="center" gap="5px">
      <div>{text}</div>
      {warnings && <WarningIndicator warnings={typeof warnings === "string" ? [warnings] : warnings} />}
    </Row>
  );
}
